/* ==========================================================================
   Theonyx theme JS — small, dependency-free, Shopify-native.
   Nothing here replaces Shopify's cart or checkout. Quick-add posts to the
   standard /cart/add.js Ajax API so Web Pixels + Shopify Analytics still
   record add-to-cart events.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------- drawers */
  var openDrawer = null;

  function closeDrawer() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (openDrawer.__opener) openDrawer.__opener.focus();
    openDrawer = null;
  }

  function showDrawer(drawer, opener) {
    if (!drawer) return;
    closeDrawer();
    drawer.__opener = opener || null;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    openDrawer = drawer;
    var focusable = drawer.querySelector('input, button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      showDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__scrim')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* --------------------------------------------- mobile nav accordions */
  $$('[data-mnav-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    });
  });

  /* ------------------------------------------------------ sticky header */
  var header = $('[data-header]');
  if (header) {
    var stick = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
    stick();
    window.addEventListener('scroll', stick, { passive: true });
  }

  /* --------------------------------------------------------- reveal-in */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ------------------------------------------------------------ gallery */
  $$('[data-gallery]').forEach(function (gallery) {
    on(gallery, 'click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-gallery-thumb');
      $$('[data-gallery-slide]', gallery).forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === id);
      });
      $$('[data-gallery-thumb]', gallery).forEach(function (t) {
        t.setAttribute('aria-current', String(t === thumb));
      });
    });
  });

  function selectMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var thumb = gallery.querySelector('[data-gallery-thumb="' + mediaId + '"]');
    if (thumb) thumb.click();
  }

  /* -------------------------------------------------- quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------ variant picker
     Reads the section's variant JSON, keeps the hidden `id` input in sync
     with the standard product form and updates the URL — the form itself is
     Shopify's, so add-to-cart and dynamic checkout behave normally.        */
  $$('[data-variant-picker]').forEach(function (picker) {
    var sectionId = picker.getAttribute('data-section');
    var dataEl = document.getElementById('VariantData-' + sectionId);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = document.getElementById('ProductForm-' + sectionId);
    var idInput = form && form.querySelector('input[name="id"]');
    var priceWrap = document.getElementById('Price-' + sectionId);
    var skuEl = document.getElementById('Sku-' + sectionId);
    var stockEl = document.getElementById('Stock-' + sectionId);
    var submit = form && form.querySelector('[data-add-button]');
    var buyNow = form && form.querySelector('[data-buy-now]');
    var gallery = $('[data-gallery]');

    function currentOptions() {
      return $$('select[data-option-index], input[data-option-index]:checked', picker)
        .sort(function (a, b) {
          return a.getAttribute('data-option-index') - b.getAttribute('data-option-index');
        })
        .map(function (el) { return el.value; });
    }

    function match(options) {
      return variants.filter(function (v) {
        return options.every(function (opt, i) { return v.options[i] === opt; });
      })[0];
    }

    function render(variant) {
      if (submit) {
        var available = variant && variant.available;
        submit.disabled = !available;
        submit.textContent = !variant
          ? (strings.unavailable || 'Unavailable')
          : (available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out'));
      }
      if (buyNow) buyNow.disabled = !(variant && variant.available);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (stockEl) {
        stockEl.textContent = variant.available ? (strings.inStock || 'In stock') : (strings.soldOut || 'Sold out');
        stockEl.classList.toggle('product__stock--out', !variant.available);
      }
      if (variant.featured_media && gallery) selectMedia(gallery, String(variant.featured_media.id));

      if (priceWrap && sectionId) {
        fetch(window.location.pathname + '?variant=' + variant.id + '&section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('Price-' + sectionId);
            if (fresh) priceWrap.innerHTML = fresh.innerHTML;
          })
          .catch(function () { /* price simply stays as rendered */ });
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    on(picker, 'change', function () { render(match(currentOptions())); });
  });

  /* --------------------------------------------------- cart count bubble */
  function refreshCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function fetchCartCount() {
    fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { refreshCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ------------------------------------------------------------ quick add
     Standard Ajax Cart API. Shopify's Web Pixel instruments this endpoint,
     so `product_added_to_cart` still fires for Analytics and Insights.     */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = strings.adding || 'Adding…'; }

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (btn) btn.textContent = strings.added || 'Added';
        fetchCartCount();
        setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1600);
      })
      .catch(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        window.location.href = routes.cart_url || '/cart';
      });
  });

  /* ------------------------------------------------- collection filtering
     Progressive enhancement over Shopify Search & Discovery facet forms:
     the form still works without JS, JS just swaps the grid in place.      */
  var facetForm = $('[data-facet-form]');
  if (facetForm) {
    var debounce;

    function applyFacets(url, push) {
      var results = $('[data-collection-results]');
      if (results) results.classList.add('loading');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-collection-results]', '[data-facet-form]', '[data-active-filters]', '[data-collection-count]'].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var current = document.querySelector(sel);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
          if (push && history.pushState) history.pushState({ facets: true }, '', url);
          window.scrollTo({ top: (document.querySelector('[data-collection-top]') || document.body).offsetTop - 90, behavior: 'smooth' });
        })
        .catch(function () { window.location.href = url; })
        .finally(function () {
          var r2 = $('[data-collection-results]');
          if (r2) r2.classList.remove('loading');
        });
    }

    document.addEventListener('change', function (e) {
      if (!e.target.closest('[data-facet-form]')) return;
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        var form = $('[data-facet-form]');
        var params = new URLSearchParams(new FormData(form));
        applyFacets(window.location.pathname + '?' + params.toString(), true);
      }, 260);
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (!link) return;
      e.preventDefault();
      applyFacets(link.href, true);
    });

    window.addEventListener('popstate', function () { applyFacets(window.location.href, false); });
  }

  /* ------------------------------------------------------------ sort by */
  var sortSelect = $('[data-sort]');
  if (sortSelect) {
    on(sortSelect, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------ cart page */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = input.getAttribute('data-cart-qty');
    fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
    }).then(function () { window.location.reload(); });
  });

  /* ---------------------------------------------------- discount popup */
  /* Shows a welcome code after a delay, once per visitor. It never locks
     body scroll and sits under the drawers, so cart and checkout stay
     usable at all times. Nothing here touches Shopify's own analytics. */
  function initDiscountPopup(scope) {
    var pop = $('[data-discount-popup]', scope || document);
    if (!pop || pop.__dpop) return;
    pop.__dpop = true;

    var panel = $('.dpop__panel', pop);
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var storageKey = pop.getAttribute('data-storage-key') || 'theonyx:discount-popup';
    var once = pop.getAttribute('data-once') === 'true';
    var hideOnCart = pop.getAttribute('data-hide-on-cart') === 'true';
    var code = pop.getAttribute('data-code') || '';
    var delay = parseInt(pop.getAttribute('data-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = 5;

    var timer = null;
    var lastFocus = null;

    function remember(value) {
      try { localStorage.setItem(storageKey, value); } catch (e) { /* private mode */ }
    }
    function answered() {
      try { return !!localStorage.getItem(storageKey); } catch (e) { return false; }
    }

    function focusables() {
      return $$('button, [href], input, select, textarea', panel).filter(function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
    }

    function open() {
      if (pop.classList.contains('is-open')) return;
      window.clearTimeout(timer);
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      var first = $('.dpop__close', pop);
      if (first) window.setTimeout(function () { first.focus(); }, 220);
    }

    function close(outcome) {
      window.clearTimeout(timer);
      if (!pop.classList.contains('is-open')) return;
      pop.classList.remove('is-open');
      if (!designMode) remember(outcome || 'dismissed');
      window.setTimeout(function () { pop.hidden = true; }, 360);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* A nav or cart drawer is open — hold off rather than stack two layers. */
    function tryOpen() {
      if ($('.drawer.is-open')) {
        timer = window.setTimeout(tryOpen, 3000);
        return;
      }
      open();
    }

    /* ------------------------------------------------------- interaction */
    on(pop, 'click', function (e) {
      if (e.target.closest('[data-dpop-close]')) {
        e.preventDefault();
        close('dismissed');
      }
    });

    on(document, 'keydown', function (e) {
      if (!pop.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        e.stopPropagation();
        close('dismissed');
        return;
      }

      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    var copyBtn = $('[data-dpop-copy]', pop);
    var live = $('[data-dpop-live]', pop);

    function copyCode() {
      if (!code || !navigator.clipboard || !navigator.clipboard.writeText) {
        return Promise.reject();
      }
      return navigator.clipboard.writeText(code);
    }

    on(copyBtn, 'click', function () {
      copyCode().then(function () {
        copyBtn.classList.add('is-copied');
        if (live) live.textContent = pop.getAttribute('data-copied-label') || '';
      }).catch(function () {
        /* Clipboard blocked — the code is on screen and selectable anyway. */
      });
    });

    var cta = $('[data-dpop-cta]', pop);
    if (cta) {
      /* Send the visitor back where they were once Shopify applies the code. */
      var href = cta.getAttribute('href') || '';
      if (href.indexOf('/discount/') !== -1 && href.indexOf('redirect=') === -1) {
        var back = window.location.pathname + window.location.search;
        cta.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') +
          'redirect=' + encodeURIComponent(back));
      }

      on(cta, 'click', function (e) {
        remember('accepted');
        if (designMode) { e.preventDefault(); close('accepted'); return; }
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        var target = cta.getAttribute('href');
        copyCode().catch(function () {}).then(function () { window.location.href = target; });
      });
    }

    /* ------------------------------------------------------------ trigger */
    if (designMode) {
      /* In the editor the popup follows the section, so it never covers
         the rest of the theme while the merchant works. */
      var sectionId = pop.getAttribute('data-section-id');
      on(document, 'shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === sectionId) open();
      });
      on(document, 'shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === sectionId) {
          pop.classList.remove('is-open');
          window.setTimeout(function () { pop.hidden = true; }, 360);
        }
      });
      return;
    }

    if (once && answered()) return;
    if (hideOnCart && document.body.classList.contains('template--cart')) return;

    timer = window.setTimeout(tryOpen, delay * 1000);
  }

  initDiscountPopup(document);
  document.addEventListener('shopify:section:load', function (e) {
    initDiscountPopup(e.target);
  });
})();
